/**
 * BrainSwipe Main Page
 *
 * Роутер между экранами BrainSwipe
 */

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSwipeStore } from '../stores/swipe';
import { BrainSwipeStart } from './BrainSwipeStart';
import { BrainSwipeGame } from './BrainSwipeGame';
import { BrainSwipeFeedback } from './BrainSwipeFeedback';
import { BrainSwipeFinished } from './BrainSwipeFinished';

export function BrainSwipePage() {
  const screen = useSwipeStore((s) => s.screen);
  const setFilters = useSwipeStore((s) => s.setFilters);
  const startGame = useSwipeStore((s) => s.startGame);
  const [searchParams] = useSearchParams();

  // Читаем фильтры из URL при загрузке
  useEffect(() => {
    const quizParam = searchParams.get('quiz');
    const tagParam = searchParams.get('tag');

    const quizIds = quizParam ? quizParam.split(',').filter(Boolean) : null;
    const tag = tagParam || null;

    // Устанавливаем фильтры
    if (quizIds || tag) {
      setFilters(quizIds, tag);
      // Автоматически начинаем игру если есть фильтры
      startGame();
    }
  }, [searchParams, setFilters, startGame]);

  switch (screen) {
    case 'start':
      return <BrainSwipeStart />;
    case 'playing':
      return <BrainSwipeGame />;
    case 'feedback':
      return <BrainSwipeFeedback />;
    case 'finished':
      return <BrainSwipeFinished />;
    default:
      return <BrainSwipeStart />;
  }
}
